export default "__VITE_ASSET__DsxYfwAE__"